'use client'

import type { DefaultCellComponentProps } from 'payload'

export function InstagramCaptionCell({ cellData }: DefaultCellComponentProps) {
  const text = (cellData as string | undefined) || ''

  return (
    <span
      style={{
        display: '-webkit-box',
        WebkitLineClamp: 2,
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        maxWidth: '420px',
      }}
    >
      {text}
    </span>
  )
}
